module.exports = __webpack_public_path__ + "static/media/brand-refresh-school.57278cd0.svg";